import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Authorization, ProjectCommunication, ProjectRole } from '@data/models/authorization.model';
import { AuthorizationService } from '@data/services/authorization.service';
import { Company } from '@data/models/company.model';
import { Role } from '@data/models/role.model';
import { AclsDetailsDialogComponent } from '@shared/components/acls-details-dialog/acls-details-dialog.component';
import { commSortingDataAccessor } from '@shared/utils/angular-material-tools';
import { User } from '@data/models/user.model';

const DEFAULT_LIST_SIZE = 10;

@Component({

    selector: 'syn-project-authorizations',
    templateUrl: 'project-authorizations.component.html',
    styleUrls: ['project-authorizations.component.scss']
})
export class ProjectAuthorizationsComponent implements OnInit {

    @Input() globalRoles: Role[] = [];
    @Input() projectRoles: ProjectRole[];
    @Input() projectCommunications: ProjectCommunication[];
    @Input() users: User[];
    @Input() companies: Company[];

    public dataSource: MatTableDataSource<Authorization>;
    public displayedColumns: String[] = ['fullName', 'company', '247', 'roles', 'mso', 'incident',
        'request', 'patch', 'change', 'billing'];
    public showPaginator = true;
    public pageSizeOptions: Number[] = [5, 10, 25, 100];
    public pageSize = DEFAULT_LIST_SIZE;
    public pageIndex = 0;

    constructor(
        private matDialog: MatDialog,
        private authorizationService: AuthorizationService
    ) { }

    @ViewChild(MatSort) set matSort(sort: MatSort) {
        if (this.dataSource) {
            this.dataSource.sort = sort;
        }
    }
    @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
        if (this.dataSource) {
            this.dataSource.paginator = paginator;
        }
    }

    ngOnInit(): void {
        const data = this.authorizationService.getProjectAuthorizations(this.projectRoles, this.projectCommunications, this.users);
        this.dataSource = new MatTableDataSource<Authorization>(data);
        this.dataSource.sortingDataAccessor = commSortingDataAccessor;
    }

    /**
     * Display roles information dialog
     */
    displayAclsInformation(row: Authorization): void {
        this.matDialog.open(AclsDetailsDialogComponent, {
            data: {
                roles: this.globalRoles,
                row: row
            },
            width: '800px'
        });
    }

    /**
     * Mat Table filter
     */
    applyFilter(term: string, input?: MatInput): void {
        this.dataSource.filter = term.trim().toLowerCase();

        if (input) {
            input.value = term;
        }
    }

}
